/** A blob: URL for PDF bytes, or null where the engine has none (old browsers, tests). Revoke it when done. */
export function pdfObjectUrl(bytes: Uint8Array): string | null {
  if (typeof URL.createObjectURL !== 'function') return null;
  return URL.createObjectURL(new Blob([bytes as BlobPart], { type: 'application/pdf' }));
}

export function revokeObjectUrl(url: string | null): void {
  if (url && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
}
